import * as React from "react";
import * as _ from "lodash";
import VrlReportList from "./vrl-trans-detail-list";

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

class VrlTransactionReport extends React.Component<{}, {}> {
    render = () => {
        return (
            <>
                <VrlReportList />
            </>
        );
    }
}

export default VrlTransactionReport;